/*
 * How a custom emoji is named, decided without the record, light enough for the web app to share:
 * the name a message writes it by (`:name:`), and the key a reaction holds it by, which is its id,
 * so renaming an emoji leaves every reaction to it standing.
 */

/** The longest a custom emoji's name may be. */
export const maxEmojiName = 48

/**
 * A custom emoji's name as Beacon keeps it: lower case, without the colons it may be typed between,
 * 2 to `maxEmojiName` letters (a to z), digits, hyphens and underscores, as a shortcode is written.
 * None for anything that can't be one.
 */
export function emojiName(typed: unknown): string | undefined {
  if (typeof typed !== "string") return undefined
  const name = typed
    .trim()
    .replace(/^:(.*):$/, "$1")
    .toLowerCase()
  return name.length >= 2 && name.length <= maxEmojiName && /^[a-z0-9_-]+$/.test(name)
    ? name
    : undefined
}

const keyPattern = /^custom:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

/** The key a reaction holds a custom emoji by: `custom:<id>`. */
export const customKeyOf = (emojiId: string) => `custom:${emojiId}`

/** The custom emoji a reaction's key names, by its id in lower case; none for any other key. */
export function customIdOf(key: string): string | undefined {
  return keyPattern.exec(key)?.[1]?.toLowerCase()
}
